import type { AddressType } from '@am3nd-org/pointcraft-types';

import { apiSender, ApiMethods, apiEndpoints } from '../axios';

export const updateBusinessFees = async ({
  customerRateSplit,
  customerFixedSplit,
  taxRate,
  acceptTips,
}: {
  customerRateSplit: number;
  customerFixedSplit: number;
  taxRate: number;
  acceptTips?: boolean;
}) => {
  try {
    const result = await apiSender(apiEndpoints.business.fees, ApiMethods.POST, {
      customerSplits: {
        rate: customerRateSplit,
        fixed: customerFixedSplit,
      },
      taxRate,
      acceptTips,
    });
    return result;
  } catch (error) {
    console.error('Failed to update business fees:', error);
    return { error: error instanceof Error ? error.message : 'Failed to update business fees' };
  }
};

export const updateBusinessConfig = async ({
  name,
  email,
  phone,
  address,
  saleFooterText,
  systemPin,
  lockoutTime,
  userPinUpdate,
  canProcessOrders,
  viewSimpleReports,
  preferences,
}: {
  name?: string;
  email?: string;
  phone?: string;
  address?: AddressType;
  saleFooterText?: string;
  systemPin?: string;
  lockoutTime?: number;
  userPinUpdate?: { pin: string; id: string };
  canProcessOrders?: boolean;
  viewSimpleReports?: boolean;
  preferences?: {
    displayBiggerTextUi?: boolean;
    printDoubleKDSReceipt?: boolean;
    linkedPrintingDevices?: Array<{
      sourceDeviceId: string;
      destinationDeviceId: string;
    }>;
    autoAcceptOrders?: boolean;
    autoPrintReceipt?: boolean;
    autoCompleteOrders?: boolean;
    restaurantPosPreferences?: {
      defaultTab?: string;
      holdOrdersEnabled?: boolean;
    };
  };
}) => {
  try {
    const result = await apiSender(apiEndpoints.business.configurations, ApiMethods.POST, {
      name,
      email,
      phone,
      address,
      saleFooterText,
      systemPin,
      lockoutTime,
      userPinUpdate,
      canProcessOrders,
      viewSimpleReports,
      preferences,
    });
    return result;
  } catch (error) {
    console.error('Failed to update business config:', error);
    return {
      error: error instanceof Error ? error.message : 'Failed to update business configuration',
    };
  }
};

export const updateItemCategories = async (payload: { add?: string[]; remove?: string[] }) => {
  try {
    const result = await apiSender(apiEndpoints.business.itemCategories, ApiMethods.POST, payload);
    return result;
  } catch (error) {
    console.error('Failed to update item categories:', error);
    return {
      error: error instanceof Error ? error.message : 'Failed to update item categories',
    };
  }
};
